import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Container, TelegramCta } from './primitives';
import { landing } from './tokens';

const WhatsAppSoon: React.FC = () => {
  const { t } = useTranslation('landing');
  return (
    <Box component='section' aria-label={t('whatsapp.title')} sx={{ pb: { xs: 9, md: 13 } }}>
      <Container>
        <Box
          sx={{
            borderRadius: '28px',
            border: '1px dashed rgba(15, 27, 31, 0.22)',
            bgcolor: landing.surface,
            p: { xs: 3.5, md: 4.5 },
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 3.5,
          }}
        >
          <Box
            sx={{
              flex: '1 1 380px',
              minWidth: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: 1.25,
            }}
          >
            <Box
              component='h2'
              sx={{ fontSize: 'clamp(26px, 2.6vw, 34px)', letterSpacing: '-0.02em' }}
            >
              {t('whatsapp.title')}
            </Box>
            <Box component='p' sx={{ color: landing.ink2, fontSize: 17, lineHeight: 1.6 }}>
              {t('whatsapp.text')}
            </Box>
          </Box>
          <TelegramCta label={t('whatsapp.cta')} tone='ink' size='md' />
        </Box>
      </Container>
    </Box>
  );
};

export default WhatsAppSoon;
